import { render, staticRenderFns } from "./AbastecimentoAdmAnaliticoRead.vue?vue&type=template&id=fe876cfc&"
import script from "./AbastecimentoAdmAnaliticoRead.vue?vue&type=script&lang=js&"
export * from "./AbastecimentoAdmAnaliticoRead.vue?vue&type=script&lang=js&"
import style0 from "./AbastecimentoAdmAnaliticoRead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports